<template>
  <div class="row">
    <div class="col">
      <!-- ARENA -->
      <div>
        <div class="widget">
          <div class="row vertical-align align-items-center">
            <button
              type="button"
              class="btn btn-circle btn-lg btn-primary mr-2"
            >
              <i class="fa fa-cogs" />
            </button>

            <h4>{{ $t('arena') }}</h4>
          </div>
        </div>

        <ul class="list-group list-group-flush bg-white" v-for="(item, index) in arena" :key="index">
          <router-link :to='`${item.path}`'>
            <li class="list-group-item text-secondary">
              {{ $t(item.text) }}
            </li>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  user,
  testRegister,
  stockRegister,
  parameters,
  consults,
  appFrotixRegisters,
  financial,
  arena
} from '@/config/settings'

export default {
  name: 'TestSettingsList',
  data: () => ({
    user: user(),
    testRegister : testRegister(),
    stockRegister: stockRegister(),
    parameters   : parameters(),
    consults     : consults(),
    appFrotixRegisters: appFrotixRegisters(),
    financial: financial(),
    arena: arena()
  })
}
</script>
